<cb-dialog [dialogHeading]="data.dialogHeading || 'Edit Council RFI'">
    <form class="flex-col flex"
          #editCouncilRfiForm="ngForm">
        <div class="flex-col flex">
            <cb-input type="text"
                      label="Council"
                      name="councilName"
                      [(ngModel)]="mappedItem.councilName"
                      [readonly]="true"></cb-input>
            @if (availableConsents.length > 0) {
                <div class="flex-col">
                    <cb-selection-list name="relatedConsents"
                                       label="Related Consent(s)"
                                       [(ngModel)]="mappedItem.relatedConsentIds"
                                       [options]="availableConsents"
                                       [optionLabel]="relatedConsentLabel"
                                       [readonly]="isReadonly"
                                       [required]="true"
                                       checkboxPosition="before">
                    </cb-selection-list>
                </div>
}
            @if (consentsRequiringConsentNumber.length > 0) {
                <div class="flex-col">
                    @for (consent of consentsRequiringConsentNumber; track consent) {
                    <cb-checkbox
                                 [ngModel]="false"
                                 [ngModelOptions]="{ standalone: true }"
                                 [readonly]="true"
                                 [slim]="true">
                        <div class="flex center-center">
                            {{consent.consentTypeLabel}} - {{consent.consentFor}}
                            <mat-icon color="warn" class="cb-margin-left"
                                      matTooltip="This consent requires Consent Number">warning</mat-icon>
                        </div>
                    </cb-checkbox>
    }
                </div>
}
            <cb-input type="text"
                      label="Received From"
                      name="receivedFrom"
                      [(ngModel)]="mappedItem.receivedFrom"
                      [readonly]="isReadonly"
                      [required]="true"></cb-input>
            <cb-input type="text"
                      label="External Reference"
                      name="externalReference"
                      [(ngModel)]="mappedItem.externalReference"
                      [readonly]="isReadonly"
                      [required]="true"></cb-input>
            <cb-datepicker label="RFI Date"
                           name="rfiDate"
                           pickerType="calendar"
                           [(ngModel)]="mappedItem.rfiDate"
                           [readonly]="isReadonly"
                           [required]="true"></cb-datepicker>
            <cb-datepicker label="RFI Due Date"
                           name="rfiDueDate"
                           pickerType="calendar"
                           [(ngModel)]="mappedItem.rfiDueDate"
                           [readonly]="isReadonly"
                           [required]="true"></cb-datepicker>
            <div class="flex-row">
                <cb-selection-list class="flex"
                                   name="rFIAspects"
                                   label="Relates To"
                                   [(ngModel)]="mappedItem.rfiAspects"
                                   [readonly]="isReadonly"
                                   [options]="rFIAspects"
                                   [required]="true"
                                   checkboxPosition="before">
                </cb-selection-list>
                <cb-select class="flex" style="height: 78px; width: 300px"
                           name="workingDrawing"
                           label="Working Drawing Revision"
                           [required]="true"
                           [options]="workingDrawings"
                           [(ngModel)]="mappedItem.workingDrawingId"></cb-select>
            </div>
            <div class="start-center flex-row">
                <div class="flex-row">
                    <cb-user-autocomplete-scroller class="flex"
                                                   label="Assign To"
                                                   name="assignTo"
                                                   [(ngModel)]="assignee"
                                                   [readonly]="isReadonly"
                                                   [requireMatch]="true"
                                                   [matchProps]="['id']"
                                                   [active]="true"
                                                   (change)="assigneeChanged()"
                                                   [required]="true"></cb-user-autocomplete-scroller>
                    @if (isReadonly) {
                        <button
                                mat-icon-button
                                color="primary"
                                class="cb-margin-left"
                                (click)="onViewAssignToClicked()">
                            <mat-icon>pageview</mat-icon>
                        </button>
                    }
                </div>
                @if (assigneeTeams.length > 1) {
                    <span class="cb-margin-left-2x cb-margin-right-2x">as</span>
                }
                @if (assigneeTeams.length > 1) {
                <cb-select
                           label="Team"
                           name="team"
                           [(ngModel)]="mappedItem.assignedToTeamId"
                           [valueProp]="'id'"
                           [readonly]="isReadonly"
                           [options]="assigneeTeams"
                           [required]="true"
                           valueProp="key"></cb-select>
}
            </div>
            <cb-text-area label="Notes"
                          name="notes"
                          [maxlength]="1000"
                          [(ngModel)]="mappedItem.notes"
                          [readonly]="isReadonly"
                          [required]="true"></cb-text-area>
        </div>
        @if (!isReadonly) {
            <div class="cb-margin-top flex-col">
                <label class="cb-margin-bottom cb-required mat-body-2">Upload Document</label>
                <cb-document-upload *cbWaitFor="document"
                                    class="cb-margin-bottom"
                                    [(documentEntityMappedItem)]="document"
                                    (documentEntityMappedItemChange)="editCouncilRfiForm.form.markAsDirty()"
                                    [hideName]="true"
                                    [hideDescription]="true"></cb-document-upload>
            </div>
        }
        @if (document?.document?.id) {
            <button mat-flat-button

                    (click)="downloadLatestRfiDocument()">
                <mat-icon>file_download</mat-icon>
                &nbsp;Download
            </button>
        }
    </form>
    <div actions>
        <button mat-raised-button
                color="primary"
                [disabled]="saveDisabled(editCouncilRfiForm)"
                (cbClick)="save()"
                [clickLimit]="1">Save
        </button>
        <button mat-raised-button
                (click)="cancel()">Cancel</button>
    </div>
</cb-dialog>
